import { CompanyInventoryItem, CompanyInventoryMaster, inventoryKindLabel } from '../../types/companyInventory';
import { groupInventoryByMaster, inventorySpecLabel } from '../../utils/inventoryGrouping';

interface Props {
  value: number | '' | null;
  items: CompanyInventoryItem[];
  masters?: CompanyInventoryMaster[];
  onChange: (inventoryId: number | null) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  /** 종류 라벨을 옵션 앞에 붙일지 */
  showKind?: boolean;
}

/** 품명(마스터) optgroup → 규격(SKU) option */
function InventorySkuSelect({
  value,
  items,
  masters,
  onChange,
  disabled,
  placeholder = '선택',
  className,
  showKind = false,
}: Props) {
  const groups = groupInventoryByMaster(items, masters);
  return (
    <select
      className={className}
      disabled={disabled}
      value={value ?? ''}
      onChange={(e) => {
        const raw = e.target.value;
        onChange(raw ? Number(raw) : null);
      }}
    >
      <option value="">{placeholder}</option>
      {groups.map((group) => (
        <optgroup
          key={group.masterId ?? `${group.itemKind}-${group.itemName}`}
          label={
            showKind
              ? `[${inventoryKindLabel(group.itemKind)}] ${group.itemName}`
              : group.itemName
          }
        >
          {group.specs.map((opt) => (
            <option key={opt.inventoryId} value={opt.inventoryId}>
              {inventorySpecLabel(opt)}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}

export default InventorySkuSelect;
